export function DrillIcon({
  name,
  size = 20,
}: {
  name:
    | "plus"
    | "arrow"
    | "back"
    | "check"
    | "miss"
    | "target"
    | "collection"
    | "calendar"
    | "video"
    | "undo"
    | "search"
    | "edit"
    | "external"
    | "up"
    | "down"
    | "sort";
  size?: number;
}) {
  const paths = {
    up: "M12 19V5m-6 6 6-6 6 6",
    down: "M12 5v14m-6-6 6 6 6-6",
    sort: "M8 4v16m-4-4 4 4 4-4M16 20V4m-4 4 4-4 4 4",
    plus: "M12 5v14M5 12h14",
    arrow: "M5 12h14m-6-6 6 6-6 6",
    back: "M19 12H5m6-6-6 6 6 6",
    check: "M20 6 9 17l-5-5",
    miss: "m6 6 12 12M18 6 6 18",
    target: "M12 3a9 9 0 1 0 9 9M12 7a5 5 0 1 0 5 5m-5 0 9-9m-5 0h5v5",
    collection: "M3 7V4h6l3 3h9v13H3zM7 12h10m-10 4h7",
    calendar: "M5 5h14v15H5zM8 3v4m8-4v4M5 10h14m-10 4h2m2 0h2",
    video: "M4 5h16v14H4zM10 9l5 3-5 3z",
    undo: "m9 4-5 5 5 5M4 9h10a6 6 0 0 1 0 12",
    search: "M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
    edit: "m15 5 4 4M4 20l5-1L21 7l-5-5L4 14z",
    external: "M14 3h7v7m0-7L10 14M10 3H3v18h18v-7",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "check" || name === "miss" ? 2 : 1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={paths[name]} />
    </svg>
  );
}
